import React from 'react';

function PosContentsProductEmpty(){

    return(
      <tr>
        <th scope="row" colSpan="5">입력된 상품이 없습니다.</th>
      </tr>
    );
}

export default PosContentsProductEmpty;